(function ($) {
    $(document).ready(function(){

        var block = $(".block-instock_layout-1"),
            blockContent = block.find(".block__content:not(.js-block-content-hide)"),
            blockSlider = blockContent.find(".block__slider"),
            blockItem = blockContent.find(".teaser"),
            blockArrows = block.find(".arrows"),
            blockFooter = block.find(".block__footer"),
            blockDots = blockFooter.find(".dots");

        var swiper_instock_1 = '';
        function paramsSlider(slidesPerView, slidesPerGroup, loop, loopFillGroupWithBlank) {
            var options = {
                init: false,
                wrapperClass: "block__slider-wrapper",
                slideClass: "teaser",
                slidesPerView: slidesPerView,
                slidesPerGroup: slidesPerGroup,
                setWrapperSize: true,
                grabCursor: true,
                spaceBetween: 16,
                watchOverflow: true,
                updateOnWindowResize: true,
                observer: true,
                observeParents: true,
                observeSlideChildren: true,
                loop: false,
                loopFillGroupWithBlank: loopFillGroupWithBlank,
                freeMode: false,
                freeModeMomentum: false,
                navigation: {
                    nextEl: ".block-instock_layout-1 .arrows__next",
                    prevEl: ".block-instock_layout-1 .arrows__prev",
                    disabledClass: "arrows__arrow_disabled",
                },
                pagination: {
                    el: ".block-instock_layout-1 .dots",
                    bulletClass: "dots__dot",
                    bulletActiveClass: "active",
                    dynamicBullets: true,
                    clickable: true,
                }
            };

            $('.block-instock_layout-1').ready(function () {
                swiper_instock_1 = new Swiper(".block-instock_layout-1 .block__content:not(.js-block-content-hide) .block__slider", options);
                swiper_instock_1.init();
            });
        }

        // 1200 - ...
        if ( $("body").width() >= 1200 ) {
            if ( blockItem.not(".swiper-slide-duplicate").length > 4 ) {
                // if ( blockSlider.hasClass(".swiper-container-initialized") ) {
                //     swiper_instock_1.destroy(true, true);
                // }
                paramsSlider(
                    slidesPerView = 4,
                    slidesPerGroup = 4,
                    loop = false,
                    loopFillGroupWithBlank = false,
                );
                blockArrows.css({"opacity":1, "visibility":"visible"});
                blockDots.show();
            } else {
                blockArrows.hide();
                blockDots.hide();
            }
        }

        // 992 - 1199
        if ( $("body").width() >= 992 && $("body").width() <= 1199 ) {
            if ( blockItem.not(".swiper-slide-duplicate").length > 3 ) {
                // if ( blockSlider.hasClass(".swiper-container-initialized") ) {
                //     swiper_instock_1.destroy(true, true);
                // }
                paramsSlider(
                    slidesPerView = 3,
                    slidesPerGroup = 3,
                    loop = true,
                    loopFillGroupWithBlank = false,
                );
                blockArrows.css({"opacity":1, "visibility":"visible"});
                blockDots.show();
            } else {
                blockArrows.hide();
                blockDots.hide();
            }
        }

        // 768 - 991
        if ( $("body").width() >= 768 && $("body").width() <= 991 ) {
            if ( blockItem.not(".swiper-slide-duplicate").length > 2 ) {
                // if ( blockSlider.hasClass(".swiper-container-initialized") ) {
                //     swiper_instock_1.destroy(true, true);
                // }
                paramsSlider(
                    slidesPerView = 2,
                    slidesPerGroup = 1,
                    loop = true,
                    loopFillGroupWithBlank = false,
                );
                blockDots.show();
            } else {
                blockDots.hide();
            }
        }

        // 640 - 767
        if ( $("body").width() >= 640 && $("body").width() <= 767 ) {
            if ( blockItem.not(".swiper-slide-duplicate").length > 2 ) {
                // if ( blockSlider.hasClass(".swiper-container-initialized") ) {
                //     swiper_instock_1.destroy(true, true);
                // }
                paramsSlider(
                    slidesPerView = 2,
                    slidesPerGroup = 1,
                    loop = true,
                    loopFillGroupWithBlank = true,
                );
                blockDots.show();
            } else {
                blockDots.hide();
            }
        }

        // ... - 639
        if ( $("body").width() <= 639 ) {
            if ( blockItem.not(".swiper-slide-duplicate").length > 1 ) {
                // if ( blockSlider.hasClass(".swiper-container-initialized") ) {
                //     swiper_instock_1.destroy(true, true);
                // }
                paramsSlider(
                    slide = 1,
                    slideGroup = 1,
                    loop = true,
                    fill = true
                );
                blockDots.show();
            } else {
                blockDots.hide();
            }
        }

    });
})(jQuery);
